<template>
  <div id="box">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <div v-if="isPage == 'index'" class="body">
        <div class="flex">
          <ul class="topBox">
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入品牌名称"></el-input>
              </div>
            </li>

            <li class="flex" style="padding-top: 5px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
          </ul>

          <div class="top_right">
            <el-button type="success" size="small" @click="addFn">新增</el-button>
            <el-button type="primary" size="small" @click="openImportDialog">导入品牌型号</el-button>
            <el-button type="primary" size="small" plain @click="openBrandSpecImportDialog">导入规格</el-button>
            <el-button type="warning" size="small" @click="openSpectrumUploadDialog">批量上传图谱</el-button>
            <el-button type="warning" size="small" @click="openTypeImageUploadDialog">批量上传型号图片</el-button>
          </div>
        </div>

        <!-- 主体内容 -->
        <div>
          <div class="table-scroll-wrap">
          <el-table :data="tableData" border style="width: 100%; margin-top: 10px">
            <el-table-column prop="name" align="center" label="品牌名称">
            </el-table-column>

            <el-table-column prop="englishName" align="center" label="英文名称">
            </el-table-column>

            <el-table-column prop="batchExample" align="center" label="批号实例" width="100">
            </el-table-column>

            <el-table-column align="center" label="品牌案例图" width="110">
              <template slot-scope="scope">
                <div class="goodsImg" v-if="scope.row.brandExampleImage">
                  <img style="width: 50px; height: 50px; object-fit: contain" :src="scope.row.brandExampleImage" alt="" @click="previewFn(scope.row.brandExampleImage)" />
                </div>
                <span v-else style="color: #999;">暂无</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="品牌图片" width="110">
              <template slot-scope="scope">
                <div class="goodsImg" v-if="scope.row.brandImage">
                  <img style="width: 50px; height: 50px; object-fit: contain" :src="scope.row.brandImage" alt="" @click="previewFn(scope.row.brandImage)" />
                </div>
                <span v-else style="color: #999;">暂无</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="型号">
              <template slot-scope="scope">
                <el-button type="success" size="small" @click="goTypeFn(scope.row)"
                  >管理</el-button
                >
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="300" class-name="brand-op-col">
              <template slot-scope="scope">
                <div class="brand-row-actions">
                  <div class="brand-row-actions-line">
                    <el-button type="warning" size="mini" @click="openBrandSpecFn(scope.row)">配置规格</el-button>
                    <el-button type="primary" size="mini" @click="linkLogicFn(scope.row)">关联逻辑</el-button>
                    <el-button type="info" size="mini" @click="viewLogicsFn(scope.row)">查看逻辑</el-button>
                  </div>
                  <div class="brand-row-actions-line">
                    <el-button type="success" size="mini" @click="editFn(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="delFn(scope.$index)">删除</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          </div>

          <list-pagination
            :total="tableTotal"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            @page-change="changePage"
            @size-change="handlePageSizeChange"
          />
        </div>
        <!-- 主体内容 -->
      </div>

      <!-- 发货 -->
      <div class="excellent_box" v-if="excellenShow == 1">
        <div class="excellent_main brand-dialog-main">
          <div class="excellent_top">
            新增品牌
            <i class="el-icon-close" @click.stop="closeFn"></i>
          </div>

          <div class="excellent_content brand-dialog-content">
            <div class="excellent_li flex">
              <span>品牌名称：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.name"
                  placeholder="请填写品牌名称"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>英文名称：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.englishName"
                  placeholder="请填写英文名称"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>批号实例：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.batchExample"
                  placeholder="请输入批号示例，如 20240319-A001"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>批号说明图：</span>
              <div style="width: 290px; display: flex; align-items: center;">
                <div style="width: 100px; height: 100px">
                  <elUpload @getImg="getImgFn" :image="addList.brandExampleImage"></elUpload>
                </div>
                <el-button v-if="addList.brandExampleImage" type="danger" size="mini" @click="addList.brandExampleImage = ''" style="margin-left: 10px;">清空</el-button>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>品牌图片：</span>
              <div style="width: 290px; display: flex; align-items: center;">
                <div style="width: 100px; height: 100px">
                  <elUpload @getImg="getBrandImgFn" :image="addList.brandImage"></elUpload>
                </div>
                <el-button v-if="addList.brandImage" type="danger" size="mini" @click="addList.brandImage = ''" style="margin-left: 10px;">清空</el-button>
              </div>
            </div>
          </div>
          <div class="excellent_btn flex">
            <el-button type="success" size="small" @click.stop="excellentFn"
              >提交</el-button
            >
            <el-button type="info" size="small" @click.stop="closeFn">取消</el-button>
          </div>
        </div>
      </div>

      <modelBox
        v-if="isPage == 'modelBox'"
        :dataList="dataList"
        @return="returnFn"
      ></modelBox>
    </div>

    <!-- 新增数据弹框 -->
    <popupBox title="输入密码" v-if="isPopup">
      <div class="popupMain">
        <div class="addLi flex">
          <div class="addLi_title">密码:</div>

          <div class="addLi_content flex">
            <div style="width: 100%">
              <el-input v-model="passwordVle" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="popupBtn flex">
        <el-button type="success" size="small" @click="confirmPasswordFn">确认</el-button>
        <el-button type="info" size="small" @click="closePasswordFn">取消</el-button>
      </div>
    </popupBox>
    <!-- 新增数据弹框 -->

    <!-- 查看关联逻辑弹窗 -->
    <div class="excellent_box" v-if="viewLogicsShow">
      <div class="excellent_main" style="height: 400px; width: 600px;">
        <div class="excellent_top">
          关联逻辑列表
          <i class="el-icon-close" @click.stop="closeViewLogicsFn"></i>
        </div>

        <div class="excellent_content" style="max-height: 320px; overflow-y: auto;">
          <el-table border :data="linkedLogicsList" style="width: 100%" v-if="linkedLogicsList.length > 0">
            <el-table-column prop="code" align="center" label="规则编码">
            </el-table-column>
            <el-table-column prop="name" align="center" label="规则名称">
            </el-table-column>
            <el-table-column prop="description" align="center" label="规则描述" min-width="200">
            </el-table-column>
            <el-table-column align="center" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="delLinkedLogicFn(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else style="text-align: center; padding: 20px; color: #999;">
            暂无关联逻辑
          </div>
        </div>
      </div>
    </div>

    <!-- 关联逻辑弹窗 -->
    <div class="excellent_box" v-if="linkLogicShow">
      <div class="excellent_main">
        <div class="excellent_top">
          关联逻辑
          <i class="el-icon-close" @click.stop="closeLinkLogicFn"></i>
        </div>

        <div class="excellent_content">
          <div class="excellent_li flex">
            <span>选择逻辑规则：</span>
            <div style="width: 290px">
              <el-select
                v-model="selectedLogicCode"
                filterable
                placeholder="请选择逻辑规则"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in logicData"
                  :value="item.code"
                  :key="index"
                  :label="item.name + ' (' + item.code + ')'"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="excellent_btn flex">
            <el-button type="success" size="small" @click.stop="confirmLinkLogicFn">提交</el-button>
            <el-button type="info" size="small" @click.stop="closeLinkLogicFn">取消</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 品牌配置规格弹窗 -->
    <div class="excellent_box brand-spec-mask" v-if="brandSpecShow" @click.self="closeBrandSpecFn">
      <div class="excellent_main brand-spec-main">
        <div class="brand-spec-header">
          <div class="brand-spec-header-text">
            <div class="brand-spec-header-title">配置规格</div>
            <div class="brand-spec-header-sub">{{ brandSpecBrandName || "" }}</div>
          </div>
          <i class="el-icon-close brand-spec-header-close" @click.stop="closeBrandSpecFn"></i>
        </div>

        <div class="brand-spec-body" v-loading="brandSpecLoading">
          <div class="brand-spec-tip">
            <i class="el-icon-info"></i>
            <span>已关联规格可点击标签移除；输入名称点「新增」可关联字典或创建后关联。</span>
          </div>

          <div class="brand-spec-panel">
            <div class="brand-spec-panel-head">
              <span class="brand-spec-panel-title">已关联</span>
              <span class="brand-spec-panel-count">{{ brandSpecLinkedDisplay.length }}</span>
            </div>

            <div v-if="brandSpecLinkedDisplay.length" class="brand-spec-tags">
              <el-tag
                v-for="item in brandSpecLinkedDisplay"
                :key="'linked-' + item.id"
                size="small"
                closable
                :disable-transitions="false"
                class="brand-spec-tag"
                :class="{ 'brand-spec-tag--removing': brandSpecRemovingId === item.id }"
                @close="removeBrandSpecLinkFn(item)"
              >{{ item.name }}</el-tag>
            </div>
            <div v-else class="brand-spec-empty">
              <i class="el-icon-folder-opened"></i>
              <span>暂无关联规格</span>
            </div>
          </div>

          <div class="brand-spec-panel brand-spec-panel--add">
            <div class="brand-spec-panel-head">
              <span class="brand-spec-panel-title">新增规格</span>
            </div>
            <div class="brand-spec-add flex">
              <el-input
                v-model="brandSpecNewName"
                size="small"
                placeholder="如 30ml、50ml、100ml"
                clearable
                :disabled="brandSpecLoading || brandSpecAdding"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                :loading="brandSpecAdding"
                :disabled="brandSpecLoading"
                @click="addBrandSpecOptionFn"
              >新增</el-button>
            </div>
          </div>
        </div>

        <div class="brand-spec-footer">
          <el-button size="small" @click.stop="closeBrandSpecFn">关闭</el-button>
        </div>
      </div>
    </div>

    <!-- 导入品牌型号弹框 -->
    <uploadModal
      :visible="importDialogVisible"
      @close="closeImportDialog"
      @success="onImportSuccess"
    ></uploadModal>

    <uploadBrandSpecModal
      :visible="brandSpecImportVisible"
      @close="closeBrandSpecImportDialog"
      @success="onBrandSpecImportSuccess"
    ></uploadBrandSpecModal>

    <!-- 批量上传图谱弹框 -->
    <uploadSpectrumModal
      :visible="spectrumUploadVisible"
      @close="closeSpectrumUploadDialog"
      @success="onSpectrumUploadSuccess"
    ></uploadSpectrumModal>

    <!-- 批量上传型号图片弹框 -->
    <uploadTypeImageModal
      :visible="typeImageUploadVisible"
      @close="closeTypeImageUploadDialog"
      @success="onTypeImageUploadSuccess"
    ></uploadTypeImageModal>
  </div>
</template>

<script>
import { delTips, returnTime, throttle } from "@/util/utils";
import modelBox from "./model.vue";
import elUpload from "@/components/elUpload";
import popupBox from "@/components/popupBox";
import uploadModal from "./uploadModal.vue";
import uploadBrandSpecModal from "./uploadBrandSpecModal.vue";
import uploadSpectrumModal from "./uploadSpectrumModal.vue";
import uploadTypeImageModal from "./uploadTypeImageModal.vue";

export default {
  components: {
    modelBox,
    elUpload,
    popupBox,
    uploadModal,
    uploadBrandSpecModal,
    uploadSpectrumModal,
    uploadTypeImageModal,
  },
  data() {
    return {
      isPage: "index",

      dataList: {},

      surplusShow: 0,
      userList: "",

      // 输入密码
      isPopup: true,
      passwordVle: "",
      tempPassword: "Csj12321",

      // 历史记录
      historyArr: ["品牌管理"],

      //  搜索
      searchVle: "",

      // 查看关联逻辑相关
      viewLogicsShow: false,
      linkedLogicsList: [],
      currentBrandId: null, // 当前查看的品牌ID

      // 关联逻辑相关
      linkLogicShow: false,
      selectedLogicCode: "",
      logicData: [],
      currentLinkBrandId: null, // 当前关联的品牌ID

      // 导入品牌型号
      importDialogVisible: false,
      brandSpecImportVisible: false,

      // 批量上传图谱
      spectrumUploadVisible: false,

      // 批量上传型号图片
      typeImageUploadVisible: false,

      // 品牌配置规格
      brandSpecShow: false,
      brandSpecLoading: false,
      brandSpecAdding: false,
      brandSpecBrandId: null,
      brandSpecBrandName: "",
      brandSpecOptions: [],
      brandSpecNameMap: {},
      brandSpecLinkedRows: [],
      brandSpecNewName: "",
      brandSpecRemovingId: null,

      // 品牌
      excellenShow: 0,

      // 添加数据
      addList: {
        name: "",
        englishName: "",
        batchExample: "",
        brandExampleImage: "",
        brandImage: "",
      },

      // 数据信息
      tableData: [],
      pageSize: 50,
      currentPage: 1,
      tableTotal: 0,
    };
  },
  computed: {
    brandSpecLinkedIdSet() {
      const set = new Set();
      (this.brandSpecLinkedRows || []).forEach((row) => {
        if (row && row.specOptionId != null) set.add(String(row.specOptionId));
      });
      return set;
    },
    brandSpecLinkedDisplay() {
      const map = this.brandSpecNameMap || {};
      return (this.brandSpecLinkedRows || [])
        .filter((row) => row && row.id != null)
        .map((row) => ({
          id: row.id,
          specOptionId: row.specOptionId,
          name: map[String(row.specOptionId)] || `规格#${row.specOptionId}`,
        }));
    },
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    // 搜索
    searchFn: function (res) {
      this.selListFn(1);
      this.currentPage = 1;
    },

    // 确认
    confirmPasswordFn() {
      let vle = this.passwordVle;
      if (!vle) {
        this.$message.error("请输入密码");
        return;
      }
      if (this.tempPassword != vle) {
        this.$message.error("您输入的密码不正确，请认证核对");
        return;
      }

      this.isPopup = false;
    },

    // 取消
    closePasswordFn() {
      this.$router.push({ path: "/user" });
    },

    // 图片预览
    previewFn(path) {
      window.open(path);
    },

    // 型号管理
    goTypeFn(list) {
      this.dataList = list;
      this.historyArr.push(list.name);
      this.isPage = "modelBox";
    },

    // 新增
    addFn() {
      this.addList = {
        name: "",
        englishName: "",
        batchExample: "",
        brandExampleImage: "",
        brandImage: "",
      };
      this.excellenShow = 1;
    },

    // 批号说明图上传回调
    getImgFn(path) {
      this.addList.brandExampleImage = path;
    },

    // 品牌图片上传回调
    getBrandImgFn(path) {
      this.addList.brandImage = path;
    },

    // 打开导入弹框
    openImportDialog() {
      this.importDialogVisible = true;
    },

    // 关闭导入弹框
    closeImportDialog() {
      this.importDialogVisible = false;
    },

    openBrandSpecImportDialog() {
      this.brandSpecImportVisible = true;
    },

    closeBrandSpecImportDialog() {
      this.brandSpecImportVisible = false;
    },

    onBrandSpecImportSuccess() {
      this.closeBrandSpecImportDialog();
    },

    // 导入成功回调
    onImportSuccess() {
      this.closeImportDialog();
      this.currentPage = 1;
      this.selListFn(1);
    },

    // 打开批量上传图谱弹框
    openSpectrumUploadDialog() {
      this.spectrumUploadVisible = true;
    },

    // 关闭批量上传图谱弹框
    closeSpectrumUploadDialog() {
      this.spectrumUploadVisible = false;
    },

    // 批量上传图谱成功回调
    onSpectrumUploadSuccess() {
      this.closeSpectrumUploadDialog();
      this.selListFn(this.currentPage);
    },

    // 打开批量上传型号图片弹框
    openTypeImageUploadDialog() {
      this.typeImageUploadVisible = true;
    },

    // 关闭批量上传型号图片弹框
    closeTypeImageUploadDialog() {
      this.typeImageUploadVisible = false;
    },

    // 批量上传型号图片成功回调
    onTypeImageUploadSuccess() {
      this.closeTypeImageUploadDialog();
      this.selListFn(this.currentPage);
    },

    // 打开品牌配置规格
    openBrandSpecFn(row) {
      if (!row || !row.id) {
        this.$message.error("品牌信息不完整");
        return;
      }
      this.brandSpecBrandId = row.id;
      this.brandSpecBrandName = row.name || row.englishName || String(row.id);
      this.brandSpecShow = true;
      this.brandSpecNewName = "";
      this.brandSpecLinkedRows = [];
      this.brandSpecOptions = [];
      this.loadBrandSpecDialogData();
    },

    closeBrandSpecFn() {
      this.brandSpecShow = false;
      this.brandSpecLoading = false;
      this.brandSpecAdding = false;
      this.brandSpecRemovingId = null;
      this.brandSpecBrandId = null;
      this.brandSpecBrandName = "";
      this.brandSpecOptions = [];
      this.brandSpecNameMap = {};
      this.brandSpecLinkedRows = [];
      this.brandSpecNewName = "";
    },

    buildBrandSpecNameMap(list) {
      const map = {};
      (list || []).forEach((x) => {
        if (x && x.id != null) map[String(x.id)] = x.name || "";
      });
      return map;
    },

    linkBrandSpecOption(specOptionId) {
      const bid = this.brandSpecBrandId;
      if (!bid || specOptionId == null) return Promise.reject();
      return this.$https(
        this.$api.api.brandSpecSave,
        {
          brandId: Number(bid),
          specOptionId: Number(specOptionId),
          isDefault: 0,
          sort: 0,
        },
        "POST"
      );
    },

    reloadBrandSpecLinkedRows() {
      const brandId = this.brandSpecBrandId;
      if (!brandId) return Promise.resolve();
      return this.$https(this.$api.api.brandSpecListJson, { brandId: brandId }, "POST").then((res) => {
        if (res.data && res.data.code == 200) {
          this.brandSpecLinkedRows = res.data.data || [];
        }
        return res;
      });
    },

    removeBrandSpecLinkFn(item) {
      if (!item || !item.id) return;
      this.$confirm("确认移除该品牌与此规格的关联？（不删除规格字典）", "提示", { type: "warning" })
        .then(() => {
          this.brandSpecRemovingId = item.id;
          return this.$https(this.$api.api.brandSpecRemoveBatch, { ids: [item.id] }, "POST");
        })
        .then((res) => {
          if (res && res.data && res.data.code == 200) {
            this.$message.success("已移除关联");
            return this.reloadBrandSpecLinkedRows();
          }
          this.$message.error((res.data && res.data.msg) || "移除失败");
        })
        .catch((err) => {
          if (err !== "cancel") {
            this.$message.error("移除失败");
          }
        })
        .finally(() => {
          this.brandSpecRemovingId = null;
        });
    },

    loadBrandSpecDialogData() {
      this.brandSpecLoading = true;
      const brandId = this.brandSpecBrandId;
      const allSpecPromise = this.$https(
        this.$api.api.specOptionPage,
        { page: 1, size: 2000 },
        "GET"
      );
      const linkedPromise = this.$https(
        this.$api.api.brandSpecListJson,
        { brandId: brandId },
        "POST"
      );
      Promise.all([allSpecPromise, linkedPromise])
        .then(([specRes, linkedRes]) => {
          if (specRes.data && specRes.data.code == 200) {
            const allList = specRes.data.data || [];
            this.brandSpecNameMap = this.buildBrandSpecNameMap(allList);
            this.brandSpecOptions = allList
              .filter((x) => x && x.id != null && Number(x.status) === 1)
              .sort((a, b) => {
                const sa = a.sort != null ? Number(a.sort) : 0;
                const sb = b.sort != null ? Number(b.sort) : 0;
                if (sa !== sb) return sa - sb;
                return Number(a.id) - Number(b.id);
              });
          } else {
            this.brandSpecOptions = [];
            this.brandSpecNameMap = {};
            this.$message.error((specRes.data && specRes.data.msg) || "获取规格字典失败");
          }

          if (linkedRes.data && linkedRes.data.code == 200) {
            this.brandSpecLinkedRows = linkedRes.data.data || [];
          } else {
            this.brandSpecLinkedRows = [];
            this.$message.error((linkedRes.data && linkedRes.data.msg) || "获取已关联规格失败");
          }
        })
        .catch(() => {
          this.brandSpecOptions = [];
          this.brandSpecNameMap = {};
          this.brandSpecLinkedRows = [];
          this.$message.error("加载规格配置失败");
        })
        .finally(() => {
          this.brandSpecLoading = false;
        });
    },

    addBrandSpecOptionFn() {
      const name = (this.brandSpecNewName || "").trim();
      if (!name) {
        this.$message.error("请输入规格名称");
        return;
      }
      const hit = (this.brandSpecOptions || []).find(
        (x) => x && String(x.name || "").trim().toLowerCase() === name.toLowerCase()
      );
      if (hit && hit.id != null) {
        if (this.brandSpecLinkedIdSet.has(String(hit.id))) {
          this.$message.warning("该规格已关联此品牌");
          this.brandSpecNewName = "";
          return;
        }
        this.brandSpecAdding = true;
        this.linkBrandSpecOption(hit.id)
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.brandSpecNewName = "";
              this.$message.success("关联成功");
              return this.reloadBrandSpecLinkedRows();
            }
            this.$message.error((res.data && res.data.msg) || "关联失败");
          })
          .catch(() => {
            this.$message.error("关联失败");
          })
          .finally(() => {
            this.brandSpecAdding = false;
          });
        return;
      }

      // 字典里可能有停用项，名称映射里再查一次
      const mapHit = Object.keys(this.brandSpecNameMap || {}).find(
        (id) => String(this.brandSpecNameMap[id] || "").trim().toLowerCase() === name.toLowerCase()
      );
      if (mapHit) {
        if (this.brandSpecLinkedIdSet.has(mapHit)) {
          this.$message.warning("该规格已关联此品牌");
          this.brandSpecNewName = "";
          return;
        }
        this.brandSpecAdding = true;
        this.linkBrandSpecOption(mapHit)
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.brandSpecNewName = "";
              this.$message.success("关联成功");
              return this.loadBrandSpecDialogData();
            }
            this.$message.error((res.data && res.data.msg) || "关联失败");
          })
          .catch(() => {
            this.$message.error("关联失败");
          })
          .finally(() => {
            this.brandSpecAdding = false;
          });
        return;
      }

      this.brandSpecAdding = true;
      this.$https(
        this.$api.api.specOptionSave,
        { name: name, sort: 0, status: 1 },
        "POST"
      )
        .then((res) => {
          if (!res.data || res.data.code != 200) {
            this.$message.error((res.data && res.data.msg) || "新增规格失败");
            return null;
          }
          const entity = res.data.data || {};
          const newId = entity.id;
          if (newId == null) {
            return this.loadBrandSpecDialogData().then(() => {
              const row = (this.brandSpecOptions || []).find(
                (x) => String(x.name || "").trim().toLowerCase() === name.toLowerCase()
              );
              return row && row.id != null ? row.id : null;
            });
          }
          return newId;
        })
        .then((specOptionId) => {
          if (!specOptionId) return;
          return this.linkBrandSpecOption(specOptionId).then((linkRes) => {
            if (linkRes.data && linkRes.data.code == 200) {
              this.brandSpecNewName = "";
              this.$message.success("新增并关联成功");
              return this.loadBrandSpecDialogData();
            }
            this.$message.error((linkRes.data && linkRes.data.msg) || "关联失败");
          });
        })
        .catch(() => {
          this.$message.error("新增规格失败");
        })
        .finally(() => {
          this.brandSpecAdding = false;
        });
    },

    // 查看关联逻辑
    viewLogicsFn: function (list) {
      this.currentBrandId = list.id;
      this.linkedLogicsList = [];
      this.viewLogicsShow = true;
      this.getLogicsByBrandId(list.id);
    },

    // 关闭查看关联逻辑弹窗
    closeViewLogicsFn: function () {
      this.viewLogicsShow = false;
      this.linkedLogicsList = [];
      this.currentBrandId = null;
    },

    // 根据品牌ID获取关联逻辑列表
    getLogicsByBrandId: function (brandId) {
      if (!brandId) {
        this.$message.error("品牌ID不能为空");
        return;
      }

      var url = this.$api.api.getLogicsByBrandId + brandId;
      this.$https(url, {}, "GET").then((res) => {
        if (res.data.code == 200) {
          this.linkedLogicsList = res.data.data || [];
        } else {
          this.linkedLogicsList = [];
          this.$message.error(res.data.msg || "查询失败");
        }
      });
    },

    // 删除关联逻辑
    delLinkedLogicFn: delTips(function (index) {
      var logic = this.linkedLogicsList[index];
      if (!logic) {
        this.$message.error("逻辑信息不完整");
        return;
      }

      // 使用关联关系的 id，如果返回的数据中有关联关系 id，使用关联关系 id
      // 否则可能需要使用其他字段，比如 relationId 或 id
      var relationId = logic.relationId || logic.id;

      if (!relationId) {
        this.$message.error("关联关系ID不能为空");
        return;
      }

      var url = this.$api.api.removeBrandBatchCalLogic + relationId;
      this.$https(url, {}, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("删除成功");
          // 重新获取关联逻辑列表
          this.getLogicsByBrandId(this.currentBrandId);
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      });
    }),

    // 关联逻辑
    linkLogicFn: function (list) {
      this.currentLinkBrandId = list.id;
      this.selectedLogicCode = "";
      this.linkLogicShow = true;
      // 如果逻辑列表为空，则获取逻辑列表
      if (this.logicData.length === 0) {
        this.selLogicListFn();
      }
    },

    // 关闭关联逻辑弹窗
    closeLinkLogicFn: function () {
      this.linkLogicShow = false;
      this.selectedLogicCode = "";
      this.currentLinkBrandId = null;
    },

    // 确认关联逻辑
    confirmLinkLogicFn: function () {
      if (!this.selectedLogicCode) {
        this.$message.error("请选择逻辑规则");
        return;
      }

      if (!this.currentLinkBrandId) {
        this.$message.error("品牌ID不能为空");
        return;
      }

      var obj = {
        brandId: this.currentLinkBrandId,
        batchCalLogicCode: this.selectedLogicCode
      };

      this.$https(this.$api.api.saveBrandBatchCalLogic, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("关联成功");
          this.closeLinkLogicFn();
          this.selListFn(this.currentPage);
        } else {
          this.$message.error(res.data.msg || "关联失败");
        }
      });
    },

    // 查询逻辑规则列表
    selLogicListFn: function () {
      var obj = {
        page: 1,
        size: 1000,
      };

      this.$https(this.$api.api.selBatchCalLogic, obj, "GET").then((res) => {
        if (res.data.code == 200) {
          this.logicData = res.data.data || [];
        } else {
          this.logicData = [];
          this.$message.error(res.data.msg || "获取逻辑列表失败");
        }
      });
    },

    // 编辑
    editFn: function (list) {
      this.addList = list;
      this.historyArr.push("编辑");
      this.excellenShow = 1;
    },

    closeFn: function () {
      this.excellenShow = 0;
      this.pageChangeShow = 1;
      this.selListFn(this.currentPage);
    },

    excellentFn: throttle(function () {
      var data = this.addList;
      if (!data.name) {
        this.$message.error("请输入品牌名称");
        return;
      } else if (!data.englishName) {
        this.$message.error("请输入英文名称");
        return;
      }
      var obj = {
        name: data.name,
        englishName: data.englishName,
        batchExample: data.batchExample || "",
        brandExampleImage: data.brandExampleImage || "",
        brandImage: data.brandImage || "",
      };

      let urls = this.$api.api.addBrand;
      if (data.id) {
        urls = this.$api.api.upBrand;
        obj.id = data.id;
      }

      // return
      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.closeFn();
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    // 查询
    selListFn: function (page) {
      var obj = {
        page: page,
        size: this.pageSize,
      };

      if (this.searchVle) {
        obj.name = this.searchVle;
      }

      this.$https(this.$api.api.selBrand, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          data.forEach((v) => {
            v.eTime = v.expiretime ? returnTime(new Date(v.expiretime)) : "";
          });
          this.tableData = data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.selListFn(this.currentPage);
      this.isPage = "index";
      this.historyArr.pop();
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    handlePageSizeChange() {
      this.selListFn(this.currentPage);
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];

      this.$https(
        this.$api.api.delBrand,
        {
          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .body {
    margin-top: 20px;
  }

  .brand-row-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 4px 0;
  }

  .brand-row-actions-line {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }

  .brand-row-actions-line .el-button + .el-button {
    margin-left: 0;
  }

  .top_right {
    display: flex;
  }

  .topBox {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
    font-size: 15px;

    li {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;

      .el-range-editor.el-input__inner {
        width: 290px;
      }
    }

    li:last-child {
      margin-right: 0px;
    }

    span {
      margin-right: 5px;
    }
  }
}

// 新增品牌
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 450px;
    height: 250px;

    &.brand-dialog-main {
      height: 440px;
      display: flex;
      flex-direction: column;

      .excellent_top {
        flex-shrink: 0;
      }

      .brand-dialog-content {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
      }

      .excellent_btn {
        flex-shrink: 0;
        margin-top: 15px;
        padding-bottom: 15px;
        justify-content: center;
      }
    }
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;
      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      width: 100%;
      margin-top: 10px;

      .excellent_li {
        margin-top: 25px;

        .el-select {
          width: 100%;
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
        }
      }

      .excellent_btn {
        justify-content: flex-end;
        margin: 25px 15px 0px 0px;
      }
    }
  }
}
// 新增品牌

.brand-spec-mask {
  backdrop-filter: blur(2px);
}

.brand-spec-main {
  width: 440px !important;
  height: auto !important;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;

  .brand-spec-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 16px 18px 14px;
    background: linear-gradient(180deg, #f8f9fb 0%, #fff 100%);
    border-bottom: 1px solid #ebeef5;
    flex-shrink: 0;
  }

  .brand-spec-header-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
    line-height: 1.3;
  }

  .brand-spec-header-sub {
    margin-top: 4px;
    font-size: 13px;
    color: #909399;
    line-height: 1.4;
    max-width: 340px;
    word-break: break-all;
  }

  .brand-spec-header-close {
    font-size: 18px;
    color: #909399;
    cursor: pointer;
    padding: 4px;
    margin-top: 2px;
    transition: color 0.2s;

    &:hover {
      color: #606266;
    }
  }

  .brand-spec-body {
    flex: 1;
    min-height: 0;
    padding: 14px 18px 6px;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .brand-spec-tip {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    font-size: 12px;
    color: #909399;
    line-height: 1.55;
    margin-bottom: 14px;
    padding: 10px 12px;
    background: #f4f6f8;
    border-radius: 6px;

    .el-icon-info {
      flex-shrink: 0;
      margin-top: 2px;
      color: #a0a8b3;
    }
  }

  .brand-spec-panel {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 12px;
    box-sizing: border-box;

    &--add {
      margin-bottom: 0;
    }
  }

  .brand-spec-panel-head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
  }

  .brand-spec-panel-title {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
  }

  .brand-spec-panel-count {
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #409eff;
    background: #ecf5ff;
    border-radius: 10px;
  }

  .brand-spec-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 200px;
    overflow-y: auto;
    padding: 2px 0;
  }

  .brand-spec-tag {
    border-radius: 4px;
    border-color: #d9ecff;
    background: #f0f7ff;
    color: #409eff;

    &.brand-spec-tag--removing {
      opacity: 0.55;
      pointer-events: none;
    }
  }

  .brand-spec-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 28px 12px;
    color: #c0c4cc;
    font-size: 13px;
    border: 1px dashed #e4e7ed;
    border-radius: 6px;
    background: #fafafa;

    .el-icon-folder-opened {
      font-size: 28px;
    }
  }

  .brand-spec-add {
    gap: 10px;

    .el-input {
      flex: 1;
    }

    .el-button {
      flex-shrink: 0;
      min-width: 72px;
    }
  }

  .brand-spec-footer {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    padding: 12px 18px 16px;
    border-top: 1px solid #ebeef5;
    background: #fff;
  }
}

//弹框数据

.popupMain {
  width: 100%;
  padding: 5px 10px;
  box-sizing: border-box;

  .addLi {
    width: 100%;
    margin-top: 10px;

    .addLi_title {
      width: 80px;
      flex-shrink: 0;
    }

    .addLi_content {
      width: 100%;
    }
  }
}

.popupBtn {
  justify-content: flex-end;
  margin: 10px auto auto auto;

  .popupBtnLi {
    cursor: pointer;
    margin-right: 6px;
  }
}

// 弹框数据

// 标准图片
.coordinateImg {
  width: 100%;
  height: 80px;
}
// 标准图片
</style>



// WEBPACK FOOTER //
// src/pages/brand/index.vue